import { render } from "./StoreDecorations.vue?vue&type=template&id=4df3c07a&scoped=true"
import script from "./StoreDecorations.vue?vue&type=script&lang=js"
export * from "./StoreDecorations.vue?vue&type=script&lang=js"

import "./StoreDecorations.vue?vue&type=style&index=0&id=4df3c07a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4df3c07a"]])

export default __exports__